module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon7.67ef62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon7.png
// module id = piG+
// module chunks = 0